import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { DateDisplay } from '../DateDisplay';
import { ItemCard } from '../ItemCard/ItemCard';
import styles from './DateSection.module.css';
import { formattedDate } from 'components/Map/util';
import { useTranslation } from 'react-i18next';

interface DateSectionProps {
  date: {
    date: string;
    items: Array<{
      pin_key: string;
      time: string;
      duration: string;
      travel_time: string;
    }>;
  };
  dayNumber: number;
  onDeleteItem: (itemIndex: number) => void;
  onTimeChange: (itemIndex: number, newTime: string) => void;
}

export const DateSection: React.FC<DateSectionProps> = ({
  date,
  dayNumber,
  onDeleteItem,
  onTimeChange,
}) => {
  const { i18n } = useTranslation();
  const { setNodeRef: setDroppableRef } = useDroppable({
    id: date.date,
  });

  return (
    <>
      <div className={styles.dateContainer}>
        <DateDisplay
          day={`Day ${dayNumber}`}
          date={formattedDate(date.date, 'D MMM', i18n.language)}
        />
      </div>
      <div ref={setDroppableRef}>
        <SortableContext
          items={date.items.map((item) => item.pin_key)}
          strategy={verticalListSortingStrategy}
        >
          <div className={styles.itemCardContainer}>
            {date.items.length === 0 ? (
              <div className={styles.emptyContainer}></div>
            ) : (
              date.items.map((item, index) => (
                <ItemCard
                  key={item.pin_key}
                  item={item}
                  date={date.date}
                  onDelete={() => onDeleteItem(index)}
                  onTimeChange={(newTime) => onTimeChange(index, newTime)}
                  defaultTime={(index > 0 && date.items[index - 1].time) || '09:00'}
                />
              ))
            )}
          </div>
        </SortableContext>
      </div>
    </>
  );
};
